module.exports = __webpack_public_path__ + "img/onboarding-decoration-1.a20f8b77.svg";